module.exports = __webpack_public_path__ + "img/center-align.e3e74479.svg";